<!--首页-->
<template>
  <div style="padding:60px 0 0 0">
    <div class="box">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <!-- <div class="search"> -->
            <!-- <img src="../../../assets/images/icon_search.png" alt srcset />
            <div class="placeholder">搜索你想要找的课程</div> -->
            <van-search
  v-model="params.keywords"
  placeholder="请输入搜索关键词"
  input-align="center"
  @input="onSearch"
/>
          <!-- </div> -->
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item,i) in recommendList" :key="i">
              <img style="width:7.1rem;border-radius:5px" :src="item.pic_url" alt="" srcset="" v-rblink= "{name:'CourseDetail',query:{id:item.id}}">
              </van-swipe-item>
          </van-swipe>
          <van-tabs v-model="active" animated class="active-tab" sticky title-active-color="#00B388" @click="onClick">
            <van-tab v-for="(item,index) in activeTab" :key="index" >
              <template #title>
                <!-- <span class="active-tab-num" v-if="item.num>0">{{item.num}}</span> -->
                {{item.name}}
              </template>
              <div class="course-box" >
                <div class="course-items" v-for="(item,i) in courseList" :key="i" @click="goCourseDetail(item.id)">
                  <div class="course-pic-box">
                    <img width="100%"  :src="item.pic_url" alt="">
                    <span v-if="item.level">{{item.level}}</span>
                  </div>
                  <div class="course-title  ">{{item.title}}</div>
                  <div class="course-price-box"><span class="course-price" v-if="item.price>0">¥{{ item.price }}</span><span class="course-num" v-if="item.video_count>0">{{item.video_count}}视频</span></div>
                </div>

              </div>
            </van-tab>
          </van-tabs>
        </van-list>
      </van-pull-refresh>
    </div>

    <TabBar :show-tab-bar="true" v-show="!isApp"></TabBar>
  </div>
</template>
<style scoped>
/* @import '../../assets/style/index.css'; */
.course-price-box{
  display: flex;
  align-items: center;
}
.course-num{
  border: 1px solid rgba(255,71,104,1);;
  color:rgba(255,71,104,1);
  display: block;
  font-size: 10px;
  height: 14px;
  line-height: 14px;
  padding: 0 5px;
  margin-left: 5px;
  border-radius: 3px;
}
.course-price{
height:20px;
font-size:20px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:red;
line-height:20px;
}
.course-title{
font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:500;
color:rgba(0,0,0,1);
line-height:28px;

}
.course-pic-box span{
  position:absolute;
  display: block;
  padding: 0 10px;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  border-radius: 0 10px 0 10px;
  color: #fff;
  font-size: 14px;
  height: 20px;
  overflow: hidden;
}
.course-pic-box img{
  /* height: 3.6rem; */
  object-fit: cover;
}
.course-pic-box {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}
.course-items{
  width: 3.45rem;
  margin-top: 0.2rem;
}
.course-box{
  width: 7.1rem;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.box >>>.van-ellipsis{
  /* overflow: unset; */
}
.box >>>.van-tabs__line{
  background: #00B388;
}
.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    /* line-height: 150px; */
    text-align: center;
    /* background-color: #39a9ed; */
  }
.box >>> .active-tab {
  margin-top: 0;
}
.placeholder {
  font-size: 28rpx;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(186, 186, 186, 1);
}
.search {
  width: 7rem;
  height: 0.6rem;
  background: rgba(239, 239, 244, 1);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px auto;
}
.search img {
  width: 0.3rem;
  height: 0.3rem;
  margin-right: 0.2rem;
}
.comments-detail-top {
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-bottom: 5px solid #f3f3f3;
  position: absolute;
  top: -10px;
  left: 10px;
}
.comments-user-desc {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.comments-user-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #586b94;
}

.zan-box {
  display: flex;
  flex-direction: row-reverse;
  padding: 5px 10px;
  border-bottom: 1px solid #e6e6e6;
}

.user-zan-face {
  width: 22px;
  height: 22px;
  border-radius: 22px;
  margin-right: 4px;
}
.zan-num {
  padding: 1px 5px;
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.comments-detail {
  background: #f3f3f3;
  margin-left: 40px;
  border-radius: 5px;
  padding-bottom: 10px;
  position: relative;
}
.activity-desc {
  padding-left: 40px;
}
.activity-detail-bottom {
  padding-left: 40px;
  margin-top: 10px;
}
.activity-place-box {
  display: flex;
  align-items: center;
}
.release-time {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
  display: flex;
  justify-content: space-between;
}
.release-time img {
  width: 28px;
  height: 26px;
}
.activity-place-box img {
  width: 15px;
  height: 20px;
}
.activity-place {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}
.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}
.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.look-info {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  line-height: 17px;
}
.video-bottom {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 5px;
}
.active-items-title-read {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 58%;
}
.active-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.news-style2 .news-img-box {
  width: 40%;
}
.news-style2 .news-img-box img {
  width: 100%;
  height: 1.4rem;
}
.news-style3 img {
  margin-top: 10px;
  width: 100%;
}

.acitve-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.active-itme-read {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.acitve-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
}
.video-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
}
.comments-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
}
.active-tab {
  margin-top: 0.6rem;
}
.active-tab-num {
  width: 0.34rem;
  height: 0.34rem;
  background: #f05656;
  text-align: center;
  line-height: 0.34rem;
  display: block;
  position: absolute;
  right: -10px;
  top: -10px;
  border-radius: 0.34rem;
  color: #fff;
}
.active-tab >>> .van-tab__text {
  position: relative;
}
.active-tab >>> .van-tabs__nav {
  background: #f8f8f8;
}
.active-tab >>> [class*="van-hairline"]::after {
  border-top: none;
}
.activity-detail-top {
  width: 100%;
  background-size: 100% 4.69rem;
  background: url("../../../assets/images/activity/pic-shuo-top-1@2x.png")
    no-repeat;
  background-size: 100%;
  position: relative;
  overflow: hidden;
}
.top-info {
  width: 6.9rem;
  height: 5.3rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 7px;
  margin: 2.1rem auto;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
}
.info-top-box {
  height: 1.45rem;
  padding: 0.26rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
}
.info-top-box img {
  width: 1.08rem;
  height: 1.08rem;
  position: absolute;
  top: -0.36rem;
}
.activity-detail-title {
  font-size: 19px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin: 5px 0;
  text-indent: 1.34rem;
}
.activity-detail-desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
}
.info-main-box {
  height: 2.4rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}
.activity-dynamic {
  height: 33px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 33px;
  text-indent: 0.28rem;
}
.info-dynamic-items {
  display: flex;
  justify-content: space-between;
  flex: 1;
}
.info-dynamic-items .dynamic-item {
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dynamic-item img {
  width: 0.6rem;
  height: 0.6rem;
  display: block;
  margin-bottom: 0.12rem;
}

.info-bottom-box {
  flex: 1;
  display: flex;
  align-items: center;
}
.info-bottom-box img {
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 0.16rem 0 0.28rem;
}
.start-immediately {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  margin-left: 0.14rem;
}
.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast,Swipe,SwipeItem,Search } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast).use(Swipe).use(SwipeItem).use(Search);
import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import TabBar from "@/components/TabBar.vue";

export default {
  name: "NewsList",
  components: {
    TabBar,
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      isApp: false,
      active: 0,
      activeTab: [
        { name: "全部", num: 0,id:0 },
      ],
      params:{
        cate_id:0,
        keywords:'',
        pageNo:1,

      },
      courseList:[],
      recommendList:[]
    };
  },
  filters: {

  },
  mounted() {
    document.title = "线上教学";
    this.isApp = window.isApp();

    this.getCourseCateList()
    this.getCourseList()
  },
  destroyed() {},
  methods: {
    onSearch(value){
      console.log(value)
      console.log(this.params.keywords)
      this.params.pageNo=1
      this.getCourseList()
    },
    onRefresh() {
      let that=this
      that.params.pageNo = 1;
      that.getCourseList();
    },
     onClick(name, title) {
      console.log(name);
       this.params.cate_id = this.activeTab[name].id
      this.params.pageNo = 1;
      this.finished = false
      this.getCourseList();
    },
    goCourseDetail(id) {
      rbLink({
        name: 'CourseDetail',
        query: {
          id: id
        }
      })
    },
    getCourseCateList(){
     this.$api.get('/api/course/cateTree',{},res=>{
       this.recommendList=res.data.recommend_list
       res.data.tree.map((item,i)=>{
        this.activeTab.push(item)

       })
      })
    },
    getCourseList(){
      let that=this
      this.$api.get('/api/course/courseList',this.params,res => {
          that.loading = false;

          if (res.data.currentpage == 1) {
            that.isLoading = false;
            that.courseList = res.data.list;
          } else {
            that.courseList = that.courseList.concat(res.data.list);
          }

          if (res.data.list.length == 0) {
            that.finished = true;
          }
          that.params.pageNo += 1;
        },
        res => {
          Toast(res.msg);
        })
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getCourseList();
        }, 500);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// CourseIndex.vue?44d8c206